import { render, staticRenderFns } from "./event-feedback.vue?vue&type=template&id=3ee587af"
import script from "./event-feedback.vue?vue&type=script&lang=js"
export * from "./event-feedback.vue?vue&type=script&lang=js"
import style0 from "./event-feedback.vue?vue&type=style&index=0&id=3ee587af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports